<!-- eslint-disable vue/no-confusing-v-for-v-if -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <main class="main main--has-floating-buttons">
    <card :title="$t('pageFindGuestProfile.card.guestSearch')" cols="12">
      <hm-card-inner>
        <hm-input v-model="search.name"
                  :lazy="false"
                  :label="$t('pageFindGuestProfile.search_input')"
                  name="search"
                  cols="12 2@hd 3@desktop 6@tablet"
                  @blur="updateSearch()">
          <template slot="icon-inline-left" slot-scope="slot">
            <icon icon="search" />
          </template>
          <template slot="icon-inline-right" slot-scope="slot">
            <input-icon-button v-if="!isEmpty(search.name)" :border="false" icon="close-text" @click="search.name = null" />
          </template>
        </hm-input>
        <hm-input-select v-model="search.limit"
                         :label="$t('pageFindGuestProfile.limit')"
                         class="hidden visible@desktop"
                         name="status"
                         cols="12 2@hd 2@desktop 6@tablet">
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="250">250</option>
          <option :value="500">500</option>
          <option :value="1000">1000</option>
        </hm-input-select>
        <hm-input v-model="filter"
                  :lazy="false"
                  :label="$t('pageFindGuestProfile.filter')"
                  name="filter"
                  cols="12 2@hd start-11@hd 3@desktop start-10@desktop 6@tablet start-7@tablet">
          <template slot="icon-inline-left" slot-scope="slot">
            <icon icon="filter" />
          </template>
          <template slot="icon-inline-right" slot-scope="slot">
            <input-icon-button v-if="!isEmpty(filter)" :border="false" icon="close-text" @click="filter = null" />
          </template>
        </hm-input>
        <span v-if="!isNil(lastSearch) && rows.length === lastSearch.limit" class="text-block text-block--small text-block--info col-12">{{ $t('pageFindGuestProfile.infoMoreResults', { results: lastSearch.limit }) }}</span>
        <span v-else-if="rows.length > 0" class="text-block text-block--small text-block--info col-12">{{ $t('pageFindGuestProfile.infoResults', { results: rows.length }) }}</span>
      </hm-card-inner>
      <hm-card-inner v-if="rows.length === 0 && isEmpty(lastSearch) && $locale.startsWith('de')">
        <h1 class="explanation-text col-12">Tipps zur Verbesserung der Suchergebnisse</h1><br>
        <span class="explanation-text col-12">
          <b>Suche</b><br>
          Die Suche wird automatisch gestartet, sobald Sie mindestens 2 Zeichen eingegeben haben und kurz aufhören zu tippen.<br><br>
          <b>Nach genau passenden Treffern suchen</b><br>
          Setzen sie den Vor- oder Nachnamen in Anführungszeichen. Beispiel: <i>"Max" Mustermann</i> findet nur Personen mit dem Namen "Max" aber nicht mit dem Namen "Maximilian".<br><br>
          <b>Wörter aus der Suche ausschließen</b><br>
          Fügen Sie einen Bindestrich (-) vor einem Wort hinzu das Sie ausschließen möchte. Beispiel: <i>Max -Mustermann</i><br><br>
          <b>Nach bestimmten Namen suchen</b><br>
          Fügen Sie ein Plus (+) vor einem Wort hinzu das Sie verpflichtend gefunden haben möchten. Geben Sie z.B. "Max Mustermann an", so wird Ihnen die Suche auch Personen mit dem Namen "Stefan Mustermann", "Hans Mustermann" oder "Maximilian Mustermann" anzeigen. Suchen Sie aber nach <i>+Max +Mustermann</i> so werden Ihnen nur Ergebnisse angezeigt die sowohl das Wort "Max" als auch das Wort "Mustermann" enthalten.<br><br>
          <b>Suchergebnisse filtern</b><br>
          Wenn Sie nach häufigen Namen suchen z.B. <i>Hans Maier</i> kann es trotzdem vorkommen, dass Sie eine Vielzahl von Ergebnissen angezeigt bekommen. Über das Eingabefeld "Filtern" (rechts oben) können Sie die Ergebnisse schnell nach folgenden Feldern filtern (Gastnummer, Name, Telefon, E-Mail, Adresse, Geburtsdatum) - so finden Sie z.B. durch die Eingabe der Postleitzahl ganz schnell den richtigen Gast.
        </span>
      </hm-card-inner>
      <hm-card-inner v-if="rows.length === 0 && !isEmpty(lastSearch)">
        <h1 class="col-12">{{ $t('pageFindGuestProfile.search.noResults') }}</h1>
      </hm-card-inner>
      <hm-card-inner v-if="rows.length > 0" :full-size="true">
        <paginated-table :items-per-page="25"
                         :rows="filteredRows"
                         :sticky="true"
                         min-width="600px"
                         columns="7 4@mobile">
          <template slot="table-head">
            <sortable-th :number="true" field="number">{{ $t('pageFindGuestProfile.search.guestNumber') }}</sortable-th>
            <sortable-th field="name">{{ $t('pageFindGuestProfile.search.name') }}</sortable-th>
            <div class="hm-table__th">{{ $t('pageFindGuestProfile.search.primaryAddress') }}</div>
            <div class="hm-table__th hidden@mobile">{{ $t('pageFindGuestProfile.search.emailAddress') }}</div>
            <div class="hm-table__th hidden@mobile">{{ $t('pageFindGuestProfile.search.phoneNumber') }}</div>
            <div class="hm-table__th hidden@mobile">{{ $t('pageFindGuestProfile.search.dateOfBirth') }}</div>
            <sortable-th field="status">{{ $t('pageFindGuestProfile.search.status') }}</sortable-th>
          </template>
          <template v-slot:default="slotProps">
            <template v-for="row in slotProps.currentPage">
              <div class="hm-table__td" @click="openGuestProfile(row.id)">{{ row.number }}</div>
              <div class="hm-table__td privacy--blur" @click="openGuestProfile(row.id)">{{ row.name }}</div>
              <div class="hm-table__td privacy--blur" @click="openGuestProfile(row.id)">{{ row.address }}</div>
              <div class="hm-table__td hidden@mobile privacy--blur" @click="openGuestProfile(row.id)">{{ row.email }}</div>
              <div class="hm-table__td hidden@mobile privacy--blur" @click="openGuestProfile(row.id)">{{ row.phoneNumber }}</div>
              <div class="hm-table__td hidden@mobile privacy--blur" @click="openGuestProfile(row.id)">{{ row.birthDate }}</div>
              <div class="hm-table__td" @click="openGuestProfile(row.id)">{{ row.status }}</div>
            </template>
          </template>
        </paginated-table>
      </hm-card-inner>
    </card>
    <hm-floating-buttons>
      <hm-floating-button :label="$t('pageFindGuestProfile.actions.createGuestProfile')" icon="plus" color="blue" @click="addGuestProfile" />
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import {
  isArray,
  join,
  isNil,
  isEmpty,
  get,
  filter,
  last,
  find,
  nth,
  template,
  clone,
  cloneDeep,
  isObject,
  debounce,
  lowerCase,
  isEqual,
} from 'lodash';
import HmCol from '../lib/layout/HmCol';
import HmTable from '../lib/table/HmTable';
import { util } from 'protobufjs/minimal';
import HmCardInner from '../lib/layout/HmCardInner';
import uuid from 'uuid';

export default {
  name: 'PageFindGuestProfile',
  components: { HmCardInner, HmCol, HmTable },

  mixins: [HotelmeisterMixin],
  props: ['test'],

  data() {
    return {
      search: {
        name: null,
        limit: 50,
      },
      lastSearch: null,
      filter: null,
      rows: [],
      debouncedUpdateSearch: null,
      key: null,
    };
  },

  computed: {
    filteredRows: function () {
      if (isEmpty(this.filter)) return this.rows;
      return this.rows.filter(it => Object.values(it).filter(str => !isEmpty(str) && lowerCase(str).indexOf(lowerCase(this.filter)) >= 0).length > 0);
    },
  },

  watch: {
    'search.name': function () {
      this.onChangeInput();
    },
    'search.limit': function () {
      this.onChangeInput();
    },
  },

  created: function () {
    this.debouncedUpdateSearch = debounce(this.updateSearch, 250);
  },

  methods: {
    openGuestProfile: function (guestProfileId) {
      this.$router.push({ name: 'guest', params: { guestProfileId: guestProfileId } });
    },
    addGuestProfile: function () {
      this.axios.post(this.serviceUrls.guest.get(this, ''), this.search.name, {
        headers: {
          'Content-Type': 'text/plain',
        },
      })
        .then((response) => {
          this.$router.push({ name: 'guest', params: { guestProfileId: response.data.data } });
        })
        .catch((error) => {
          this.showMessages(error.response);
        });
    },
    onClickSearch: function () {
      this.updateSearch();
    },
    onChangeInput: function () {
      if (!isNil(this.debouncedUpdateSearch)) {
        this.debouncedUpdateSearch();
        this.filter = null;
      }
    },
    updateSearch: function () {
      if (isEmpty(this.search.name) || this.search.name.length < 2) {
        this.rows = [];
        this.lastSearch = null;
        return;
      }

      const currentSearch = cloneDeep(this.search);

      if (isEqual(currentSearch, this.lastSearch)) {
        return;
      } else {
        this.lastSearch = currentSearch;
      }

      const key = uuid.v4();
      this.key = key;

      this.axios.get(this.serviceUrl('guest.find'), {
        params: {
          q: this.search.name,
          limit: this.search.limit,
        },
      })
        .then((response) => {
          if (key === this.key) {
            this.rows = response.data.data;
          }
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';

  .hm-table__td {
    cursor: pointer;
  }
</style>

<style lang="scss">
  @import '~styles/import';

</style>



// WEBPACK FOOTER //
// src/components/pages/PageFindGuestProfile.vue